/**
 * Account Area Menu Configuration
 * Centralized menu structure for AccountSidebar
 *
 * Menu Order (2026+ UX):
 * 1. Dashboard (no children)
 * 2. Monitoring (all tools consolidated)
 * 3. My Orders (all order statuses)
 * 4. Settings (Profile + Billing + Data Management merged)
 * 5. Support (help resources)
 * 6. Buy Now (products - at bottom)
 */

export const menuItems = [
  // 1. DASHBOARD
  {
    key: 'dashboard',
    label: 'Dashboard',
    icon: 'DashboardOutlined',
    path: '/account/dashboard',
  },

  // 2. TOOLS (All tools consolidated)
  {
    key: 'tools',
    label: 'Tools',
    icon: 'Tool',
    path: '/account/tools', // Landing page
    children: [
      {
        key: 'vmc-validator',
        label: 'VMC record checker',
        path: '/account/tools/vmc-validator',
      },
      {
        key: 'dmarc-inspector',
        label: 'DMARC record checker',
        path: '/account/tools/dmarc-inspector',
      },
      {
        key: 'bimi-checker',
        label: 'BIMI record checker',
        path: '/account/tools/bimi-checker',
      },
      {
        key: 'txt-checker',
        label: 'TXT record checker',
        path: '/account/tools/txt-checker',
      },
      {
        key: 'cname-checker',
        label: 'CNAME record checker',
        path: '/account/tools/cname-checker',
      },
      {
        key: 'domain-records',
        label: 'Domain record checker',
        path: '/account/tools/domain-records',
      },
      {
        key: 'spf-lookup',
        label: 'SPF record lookup',
        path: '/account/tools/spf-lookup',
      },
      {
        key: 'dkim-lookup',
        label: 'DKIM record lookup',
        path: '/account/tools/dkim-lookup',
      },
      {
        key: 'dmarc-generator',
        label: 'DMARC generator',
        path: '/account/tools/dmarc-generator',
      },
      {
        key: 'spf-generator',
        label: 'SPF generator',
        path: '/account/tools/spf-generator',
      },
      {
        key: 'dkim-generator',
        label: 'DKIM generator',
        path: '/account/tools/dkim-generator',
      },
      {
        key: 'bimi-generator',
        label: 'BIMI generator',
        path: '/account/tools/bimi-generator',
      },
    ],
  },

  // 3. MY ORDERS (All order statuses)
  {
    key: 'orders',
    label: 'My Orders',
    icon: 'ShoppingOutlined',
    path: '/account/orders?status=all', // Landing page (all orders)
    children: [
      {
        key: 'active-orders',
        label: 'Active orders',
        path: '/account/orders?status=active',
      },
      {
        key: 'pending-orders',
        label: 'Pending orders',
        path: '/account/orders?status=pending',
      },
      {
        key: 'incomplete-orders',
        label: 'Incomplete orders',
        path: '/account/orders?status=incomplete',
      },
      {
        key: 'expiring-orders',
        label: 'Expiring orders',
        path: '/account/orders?status=expiring',
      },
    ],
  },

  // 4. SETTINGS (Profile + Notifications + Organizations + Contacts + Billing merged)
  {
    key: 'settings',
    label: 'Settings',
    icon: 'SettingOutlined',
    path: '/account/settings', // Landing page
    children: [
      {
        key: 'profile',
        label: 'Profile',
        path: '/account/settings/profile',
      },
      {
        key: 'notifications',
        label: 'Notifications',
        path: '/account/settings/notifications',
      },
      {
        key: 'organizations',
        label: 'Organizations',
        path: '/account/settings/organizations',
      },
      {
        key: 'contacts',
        label: 'Contacts',
        path: '/account/settings/contacts',
      },
      {
        key: 'transactions',
        label: 'Transaction history',
        path: '/account/billing/transactions',
      },
      {
        key: 'payment-methods',
        label: 'Payment methods',
        path: '/account/billing/payment-methods',
      },
    ],
  },

  // 5. SUPPORT (Help resources)
  {
    key: 'support',
    label: 'Support',
    icon: 'CustomerServiceOutlined',
    path: '/account/support', // Landing page (contact support cards)
    children: [
      {
        key: 'knowledge-base',
        label: 'Knowledge base',
        path: '/help-center',
        target: '_blank',
      },
      {
        key: 'faqs',
        label: 'FAQs',
        path: '/faq',
        target: '_blank',
      },
      {
        key: 'glossary',
        label: 'Glossary',
        path: '/glossary',
        target: '_blank',
      },
      {
        key: 'validation-guide',
        label: 'Validation guide',
        path: '/docs/Mark-Certificate-Validation-Guide.pdf',
        target: '_blank',
      },
      {
        key: 'schedule-validation-calls',
        label: 'Schedule validation calls',
        path: 'https://callscheduler.digicert.com/v2/#book',
        target: '_blank',
      },
    ],
  },

  // 6. BUY NOW (Products - at bottom)
  {
    key: 'buyNow',
    label: 'Buy Now',
    icon: 'ShoppingCartOutlined',
    path: '/account/buy-now', // Landing page with product cards
    children: [
      {
        key: 'mark-certificates',
        label: 'Mark Certificates',
        path: '/products/digicert-mark-certificates',
        target: '_blank',
      },
      {
        key: 'verified-mark-certificate',
        label: 'Verified Mark Certificate',
        path: '/products/digicert-verified-mark-certificate',
        target: '_blank',
      },
      {
        key: 'common-mark-certificate',
        label: 'Common Mark Certificate',
        path: '/products/digicert-common-mark-certificate',
        target: '_blank',
      },
      {
        key: 'government-mark-certificate',
        label: 'Government Mark Certificate',
        path: '/products/digicert-government-mark-certificate',
        target: '_blank',
      },
      {
        key: 'dmarc-enforcement',
        label: 'DMARC Enforcement',
        path: '/products/easydmarc-enforcement',
        target: '_blank',
      },
    ],
  },
];

export default menuItems;
